import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import { createMarkupWithOption } from '../../models/Common'
import { IQuizOption } from '../../models/WorkplaceQuiz'
import Conditional from '../common/Conditional'

export interface IWorkplaceQuizModuleQuestionOptionProps {
  option: IQuizOption
  totalSelected: number
  maxCorrect: number
  onSelection: (option: IQuizOption) => void
}

const WorkplaceQuizModuleQuestionOption = forwardRef(
  (props: IWorkplaceQuizModuleQuestionOptionProps, ref) => {
    const mountedRef = useRef(false)
    const [toggleOptionState, setToggleOptionState] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [option, setOption] = useState<IQuizOption>()

    useEffect(() => {
      mountedRef.current = true
      if (mountedRef.current) {
        setToggleOptionState(props.option.selected)
        setOption(props.option)
        setIsLoading(false)
      }
      return () => {
        mountedRef.current = false
      }
    }, [props.option])

    const onKeyPressSelect = (event) => {
      //If multi select option then it should not allow user to select options more then the correct answers

      if (event.keyCode === 13) {
        if (option?.multiselect) {
          if (
            toggleOptionState === false &&
            props.totalSelected >= props.maxCorrect
          ) {
            return
          }
        }

        setToggleOptionState((state) => !state)
        props.option.selected = !toggleOptionState

        if (props.onSelection) {
          props.onSelection(props.option)
        }
      }
    }

    const toggleOption = () => {
      //If multi select option then it should not allow user to select options more then the correct answers
      if (option?.multiselect) {
        if (
          toggleOptionState === false &&
          props.totalSelected >= props.maxCorrect
        ) {
          return
        }
      }

      setToggleOptionState((state) => !state)
      props.option.selected = !toggleOptionState

      if (props.onSelection) {
        props.onSelection(props.option)
      }
    }

    useImperativeHandle(ref, () => ({
      toggleOff() {
        setToggleOptionState(false)
      },
    }))

    return (
      <Conditional if={!isLoading}>
        <li
          onClick={
            !toggleOptionState || option?.multiselect ? toggleOption : null
          }
          onKeyDown={
            !toggleOptionState || option?.multiselect ? onKeyPressSelect : null
          }
          role="tab"
          tabIndex={0}
        >
          <a className="barClicker option clickable" aria-live="assertive">
            <div className={toggleOptionState ? 'left selected' : 'left'}>
              <div className="imgContainer">
                <img
                  src={
                    toggleOptionState
                      ? '/public/workplace/assets/images/button/clear/radio_on.png'
                      : '/public/workplace/assets/images/button/clear/radio.png'
                  }
                  alt=""
                />
              </div>
            </div>
            <div className="center">
              <div
                className="textContainer a"
                dangerouslySetInnerHTML={createMarkupWithOption(
                  option?.content,
                  { ADD_ATTR: ['target'] }
                )}
              ></div>
            </div>
            <div className="right"></div>
          </a>
        </li>
      </Conditional>
    )
  }
)

WorkplaceQuizModuleQuestionOption.displayName =
  'WorkplaceQuizModuleQuestionOption'
export default WorkplaceQuizModuleQuestionOption
